import store from '@/state/store'

export default [
    {
        path: '/login',
        name: 'login',
        component: () => import('../views/pages/account/login'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters['auth/loggedIn']) {
                    // Redirect to the home page instead
                    next({ name: 'home' })
                } else {
                    // Continue to the login page
                    next()
                }
            },
        },
    },
    {
        path: '/register',
        name: 'register',
        component: () => import('../views/pages/account/register'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters['auth/loggedIn']) {
                    // Redirect to the home page instead
                    next({ name: 'home' })
                } else {
                    // Continue to the login page
                    next()
                }
            },
        },
    },
    {
        path: '/forgot-password',
        name: 'Forgot-password',
        component: () => import('../views/pages/account/forgot-password'),
        meta: {
            beforeResolve(routeTo, routeFrom, next) {
                // If the user is already logged in
                if (store.getters['auth/loggedIn']) {
                    // Redirect to the home page instead
                    next({ name: 'home' })
                } else {
                    // Continue to the login page
                    next()
                }
            },
        },
    },
    {
        path: '/agreement-consent',
        name: 'agreement-consent',
        component: () => import('../views/pages/account/agreement-consent'),
        meta: {
            authRequired: true,
        },
    },
    {
        path: '/logout',
        name: 'logout',
        meta: {
            authRequired: true,
            beforeResolve(routeTo, routeFrom, next) {
                // 先清理权限管理器
                if (window.Vue && window.Vue.prototype.$clearPermissions) {
                    window.Vue.prototype.$clearPermissions();
                }
                
                if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
                    store.dispatch('auth/logOut')
                } else {
                    store.dispatch('authfack/logout')
                }
                const authRequiredOnPreviousRoute = routeFrom.matched.some(
                    (route) => route.push('/login')
                )
                // Navigate back to previous page, or home as a fallback
                next(authRequiredOnPreviousRoute ? { name: 'home' } : { ...routeFrom })
            },
        },
    },
    {
        path: '/',
        name: 'home',
        meta: {
            authRequired: true,
        },
        component: () => import('../views/pages/dashboard/index')
    },
    {
        path: '/console',
        name: "console",
        meta: {
            authRequired: true,
            permission: 'admin.view'
        },
        component: () => import('../views/pages/system/console')
    },
    {
        path: '/device/list',
        name: "Device List",
        meta: { authRequired: true, permission: 'device.view' },
        component: () => import('../views/pages/devices/lists')
    },
    {
        path: '/device/devicedetail',
        name: "Device Detail",
        meta: { authRequired: true, permission: 'device.view' },
        component: () => import('../views/pages/devices/devicedetail')
    },
    {
        path: '/device/orders',
        name: "Order List",
        meta: { authRequired: true, permission: 'order.view' },
        component: () => import('../views/pages/devices/orders')
    },
    {
        path: '/device/orderdetail',
        name: "Order Detail",
        meta: { authRequired: true, permission: 'order.view' },
        component: () => import('../views/pages/devices/orderinfo')
    },
    {
        path: '/device/stock',
        name: "Device Stock",
        meta: { authRequired: true, permission: 'device.view' },
        component: () => import('../views/pages/devices/stock')
    },
    {
        path: '/device/group',
        name: "Device Group",
        meta: { authRequired: true, permission: 'device.view' },
        component: () => import('../views/pages/devices/group')
    },
    {
        path: '/device/stockbind',
        name: "Device Stock Binding",
        meta: { authRequired: true, permission: 'device.edit' },
        component: () => import('../views/pages/devices/stockbind')
    },
    {
        path: '/device/ads',
        name: "Device AD",
        meta: { authRequired: true, permission: 'device.edit' },
        component: () => import('../views/pages/devices/ads')
    },
    {
        path: '/device/hd',
        name: "Device HD",
        meta: { authRequired: true, permission: 'device.edit' },
        component: () => import('../views/pages/devices/hd')
    },
    {
        path: '/device/console',
        name: "Console",
        meta: { authRequired: true, permission: 'device.edit' },
        component: () => import('../views/pages/devices/console')
    },
    {
        path: '/device/grouporder',
        name: "Gourp Order",
        meta: { authRequired: true, permission: 'order.view' },
        component: () => import('../views/pages/devices/grouporder')
    },
    {
        path: '/device/baropen',
        name: "Bar Counter",
        meta: { authRequired: true, permission: 'device.edit' },
        component: () => import('../views/pages/devices/baropen')
    },
    {
        path: '/device/barclose',
        name: "Bar Counter Close",
        meta: { authRequired: true, permission: 'device.edit' },
        component: () => import('../views/pages/devices/barclose')
    },
    {
        path: '/device/cocktailsetting',
        name: "Cocktail Setting",
        meta: { authRequired: true, permission: 'device.edit' },
        component: () => import('../views/pages/devices/cocktailsetting')
    },
    {
        path: '/iot/gateway',
        name: "IOT Gateway",
        meta: { authRequired: true, permission: 'device.view' },
        component: () => import('../views/pages/iot/gateway')
    },
    {
        path: '/iot/gatewaydetail',
        name: "Gateway Detail",
        meta: { authRequired: true, permission: 'device.view' },
        component: () => import('../views/pages/iot/gatewayinfo')
    },
    {
        path: '/iot/printer',
        name: "Printer",
        meta: { authRequired: true, permission: 'device.view' },
        component: () => import('../views/pages/iot/printer')
    },
    {
        path: '/iot/printerinfo',
        name: "Printer Info",
        meta: { authRequired: true, permission: 'device.view' },
        component: () => import('../views/pages/iot/printerinfo')
    },
    {
        path: '/iot/printertemplate',
        name: "Printer Template",
        meta: { authRequired: true, permission: 'device.edit' },
        component: () => import('../views/pages/iot/printertemplate')
    },
    {
        path: '/app/my',
        name: 'My APPs',
        meta: { authRequired: true, permission: 'system.view' },
        component: () => import('../views/pages/app/my')
    },
    {
        path: '/app/shop',
        name: 'APPs',
        meta: { authRequired: true, permission: 'system.view' },
        component: () => import('../views/pages/app/shop')
    },
    {
        path: '/app/bill',
        name: 'APP Bill',
        meta: { authRequired: true, permission: 'system.view' },
        component: () => import('../views/pages/app/bill')
    },
    {
        path: '/wechat/mp',
        name: 'Wechat MP',
        meta: { authRequired: true, permission: 'wechat.view' },
        component: () => import('../views/pages/wechat/mp')
    },
    {
        path: '/wechat/micoapp',
        name: 'Wechat Micoapp',
        meta: { 
            authRequired: true,
            permission: 'wechat.view'
        },
        component: () => import('../views/pages/wechat/micoapp')
    },
    {
        path: '/setting/account',
        name: 'Account Setting',
        meta: { authRequired: true},
        component: () => import('../views/pages/setting/account')
    },
    {
        path: '/setting/safty',
        name: 'Safty Setting',
        meta: { authRequired: true},
        component: () => import('../views/pages/setting/safty')
    },
    {
        path: '/setting/commonly',
        name: 'Commonly Setting',
        meta: { authRequired: true},
        component: () => import('../views/pages/setting/commonly')
    },
    {
        path: '/setting/system',
        name: 'System Setting',
        meta: { authRequired: true, permission: 'system.view' },
        component: () => import('../views/pages/setting/system')
    },
        {
        path: '/setting/admins',
        name: 'Admins Setting',
        meta: { 
            authRequired: true,
            permission: 'admin.view'
        },
        component: () => import('../views/pages/setting/admins')
    },
    {
        path: '/setting/permission',
        name: 'Permission Management',
        meta: { 
            authRequired: true,
            permission: 'permission.view'
        },
        component: () => import('../views/pages/setting/permission')
    },
    {
        path: '/403',
        name: '403 Forbidden',
        meta: { authRequired: true },
        component: () => import('../views/pages/error/403')
    },
    {
        path: '/setting/hardware/bluetooth',
        name: 'Bluetooth Setting',
        meta: { authRequired: true, permission: 'system.view' },
        component: () => import('../views/pages/setting/hardware/bluetooth')
    },
    {
        path: '/sales/orders',
        name: 'Sales Order List',
        meta: { authRequired: true, permission: 'order.view' },
        component: () => import('../views/pages/sales/orders')
    },
    {
        path: '/sales/paysetting',
        name: 'Payment Setting',
        meta: { authRequired: true, permission: 'system.edit' },
        component: () => import('../views/pages/sales/paysetting')
    },
    {
        path: '/sales/sharingmrg',
        name: 'Sharing Setting',
        meta: { authRequired: true, permission: 'system.edit' },
        component: () => import('../views/pages/sales/sharing')
    },
    {
        path: '/goods/list',
        name: 'Goods List',
        meta: { authRequired: true, permission: 'goods.view' },
        component: () => import('../views/pages/goods/list')
    },
    {
        path: '/goods/bind',
        name: 'BindDevices',
        meta: { authRequired: true, permission: 'goods.edit' },
        component: () => import('../views/pages/goods/bind')
    },
    {
        path: '/goods/detail',
        name: 'Goods Detail',
        meta: { authRequired: true, permission: 'goods.view' },
        component: () => import('../views/pages/goods/detail')
    },
    {
        path: '/goods/add',
        name: 'Goods Add',
        meta: { authRequired: true, permission: 'goods.add' },
        component: () => import('../views/pages/goods/add')
    },
    {
        path: '/admin/list',
        name: 'Administrators List',
        meta: { authRequired: true, permission: 'admin.view' },
        component: () => import('../views/pages/admin/list')
    },
    {
        path: '/admin/detail',
        name: 'Administrators Detail',
        meta: { authRequired: true, permission: 'admin.view' },
        component: () => import('../views/pages/admin/detail')
    },
    {
        path: '/admin/add',
        name: 'Administrators Add',
        meta: {
            authRequired: true,
            permissionsAny: ['admin.add', 'admin.edit'],
        },
        component: () => import('../views/pages/admin/add')
    },
    {
        path: '/user/list',
        name: 'User List',
        meta: { authRequired: true, permission: 'user.view' },
        component: () => import('../views/pages/user/list')
    },
    {
        path: '/user/detail',
        name: 'User Detail',
        meta: { authRequired: true, permission: 'user.view' },
        component: () => import('../views/pages/user/detail')
    },
    {
        path: '/user/add',
        name: 'User Add',
        meta: { authRequired: true, permission: 'user.add' },
        component: () => import('../views/pages/user/add')
    },
    {
        path: '/user/edit',
        name: 'User Edit',
        meta: { authRequired: true, permission: 'user.edit' },
        component: () => import('../views/pages/user/edit')
    },
    {
        path: '/user/group',
        name: 'User Group',
        meta: { authRequired: true, permission: 'user.view' },
        component: () => import('../views/pages/user/group')
    },
    {
        path: '/user/temporary',
        name: 'User Temporary',
        meta: { authRequired: true, permission: 'user.view' },
        component: () => import('../views/pages/user/temporary')
    },
    {
        path: '/user/temporary-orders',
        name: 'User Temporary Orders',
        meta: { authRequired: true, permission: 'user.view' },
        component: () => import('../views/pages/user/temporary-orders')
    },
    {
        path: '/debug/user',
        name: 'User Debug',
        meta: { authRequired: true, permission: 'permission.view' },
        component: () => import('../views/pages/debug/user')
    },
    {
        path: '/test/permission-test',
        name: 'Permission Test',
        meta: { authRequired: true, permission: 'permission.view' },
        component: () => import('../views/pages/test/permission-test')
    },
    {
        path: '/system',
        name: 'System Info',
        meta: { authRequired: true, permission: 'system.view' },
        component: () => import('../views/pages/system/index')
    },
    {
        path: "/app/backup",
        name: "Backup",
        meta: { authRequired: true, permission: 'system.edit' },
        component: () => import('../views/pages/extend/backup')
    },
    {
        path: "/app/remote",
        name: "Remote",
        meta: { authRequired: true, permission: 'system.edit' },
        component: () => import('../views/pages/extend/remote')
    },
    {
        path: "/app/domain",
        name: "Domain",
        meta: { authRequired: true, permission: 'system.edit' },
        component: () => import('../views/pages/extend/domain')
    },
    {
        path: "/about",
        name: "About",
        meta: { authRequired: true},
        component: () => import('../views/pages/extend/about')
    },
    {
        path: "/marketing/wristband",
        name: "WristbandMarketing",
        meta: { 
            authRequired: true,
            permission: 'marketing.view'
        },
        component: () => import('../views/pages/marketing/wristband')
    },
    {
        path: "/marketing/billing",
        name: "BillingMarketing",
        meta: { 
            authRequired: true,
            permission: 'marketing.view'
        },
        component: () => import('../views/pages/marketing/billing')
    },
    {
        path: "/marketing/qrcode-drink-label",
        name: "QrcodeDrinkLabel",
        meta: {
            authRequired: true,
            permission: 'marketing.view'
        },
        component: () => import('../views/pages/marketing/qrcode-drink-label')
    },
    {
        path: "/user/amountlog",
        name: "UserAmountLog",
        meta: { authRequired: true, permission: 'user.view' },
        component: () => import('../views/pages/user/amountlogs')
    },
    {
        path: "/user/orderlogs",
        name: "UserOrderLog",
        meta: { authRequired: true, permission: 'user.view' },
        component: () => import('../views/pages/user/orderlogs')
    },
    {
        path: "/messages",
        name: "Messages",
        meta: { authRequired: true, permission: 'system.view' },
        component: () => import('../views/pages/system/messages')
    },
    {
        path: "/clouds/nfcreader",
        name: "Nfcreader",
        meta: { authRequired: true, permission: 'device.view' },
        component: () => import('../views/pages/clouds/nfcreader')
    },
    {
        path: "/clouds/nfcreader/add",
        name: "AddNfcreader",
        meta: { authRequired: true, permission: 'device.edit' },
        component: () => import('../views/pages/clouds/nfcreader_bind')
    },
    {
        path: "/clouds/printer",
        name: "Cloud Printer",
        meta: { authRequired: true, permission: 'device.view' },
        component: () => import('../views/pages/clouds/printer')
    },
    {
        path: "/clouds/printer/template",
        name: "CloudPrinterTemplate",
        meta: { authRequired: true, permission: 'device.view' },
        component: () => import('../views/pages/clouds/printer-template')
    },
    {
        path: "/clouds/notify",
        name: "CloudNotify",
        meta: { 
            authRequired: true,
            permission: 'system.edit'
        },
        component: () => import('../views/pages/clouds/notify')
    },
    {
        path: "/clouds/payment",
        name: "AicoPay",
        meta: { 
            authRequired: true,
            permission: 'system.edit'
        },
        component: () => import('../views/pages/clouds/payment')
    },
    {
        path: "/clouds/cloud-bind",
        name: "CloudPlatformBind",
        meta: {
            authRequired: true,
            permission: 'system.edit'
        },
        component: () => import('../views/pages/clouds/cloud_bind')
    },
    {
        path: "/sync/auth/callback",
        name: "CloudBindCallback",
        meta: {
            authRequired: true,
            permission: 'system.edit'
        },
        component: () => import('../views/pages/clouds/cloud_bind_callback')
    },
    {
        path: "/cashier",
        name: "Cashier",
        meta: { 
            authRequired: true,
            permission: 'marketing.view'
        },
        component: () => import('../views/pages/marketing/cashier')
    },
    {
        path: "/initialization",
        name: "Initialization",
        meta: { authRequired: true, permission: 'system.edit' },
        component: () => import('../views/pages/setting/initialization')
    },
    {
        path: "/statistics",
        name: "Statistics",
        meta: { authRequired: true, permission: 'system.view' },
        component: () => import('../views/pages/system/statistics')
    },
    {
        path: "/export",
        name: "ExportCenter",
        meta: { authRequired: true, permission: 'system.view' },
        component: () => import('../views/pages/system/export-center')
    },
    {
        path: "*",
        component: () => import('../views/pages/utility/error-404')
    }
]
